import styled, { css } from 'styled-components';

const InputVariants = {
  error: css`
    border: 2px solid ${({ theme }) => theme.COLORS.ERROR};
  `
};

export const StyledInput = styled.input`
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
  border-radius: 3px;
  padding: 10px 12px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  width: ${props => props.width}px;

  ${({ variant }) => InputVariants[variant]}

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    width: 100%;
  }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export default StyledInput;
